export default __webpack_public_path__ + "static/media/exchange_2.13b24d74.png";